// WARNING: Assets are served from the Editor's version of the player
// Either update the Editor or use the theatro360-manual-assets S3 bucket

// const s3 = "https://theatro360-manual-assets.s3-us-west-2.amazonaws.com";
// const origin = window.location.origin + "/tour/assets";

export const getBaseplate = () => {
  const subdomain = window.location.host.split(".")[0];
  const origin = window.location.origin + "/tour/assets";
  switch (subdomain) {
    case "burgess":
      return `${origin}/burgess-baseplate.png`;
    case "skanska":
      return `${origin}/skanska-baseplate.png`;
    case "mayfair":
      return `${origin}/mayfair-baseplate.png`;
    case "radisson":
      return `${origin}/radisson-baseplate.png`;
    case "diageo":
      return `${origin}/blank-baseplate.png`;
    case "ventura":
      return `${origin}/ventura-baseplate.png`;
    case "cdw":
      return `${origin}/cdw-baseplate.png`;
    case "britishairways":
      return `${origin}/britishairways-baseplate.png`;
    case "mys":
      return `${origin}/MYS-grey-baseplate.png`;
    case "propertyjigsaw":
      return `${origin}/pj-baseplate.png`;
    case "kk":
      return `${origin}/kk-baseplate.jpg`;
    case "edmiston":
      return `${origin}/edmiston-baseplate.png`;
    case "northropjohnson":
      return `${origin}/N&J-baseplate.png`;
    case "fraser":
      return `${origin}/fraser-baseplate.png`;
    case "yco":
      return `${origin}/yco-baseplate.png`;
    case "lyc":
      return `${origin}/lyc-baseplate.png`;
    default:
      return `${origin}/baseplate-theatro.png`;
  }
};

export const getLoader = () => {
  const subdomain = window.location.host.split(".")[0];
  const origin = window.location.origin + "/tour/assets";
  switch (subdomain) {
    case "burgess":
      return {
        src: `${origin}/burgess_loader.png`,
        color: "rgba(23, 190, 218, 0.7)",
      };
    case "kk":
      return {
        src: `${origin}/kk-thumbnail-hover.jpg`,
        color: "rgba(255, 255, 255)", // image has no transparency
      };
    default:
      return {
        src: `${origin}/hover-icon.svg`,
        color: "rgba(34, 34, 34, 0.7)",
        position: "calc(50% - 1px) calc(50% + 15px)",
      };
  }
};

export const getPins = () => {
  const subdomain = window.location.host.split(".")[0];
  const origin = window.location.origin + "/tour/assets";
  switch (subdomain) {
    case "edmiston":
      return {
        hover: `${origin}/deck-hotspot-hover-edmiston.png`,
        default: `${origin}/deck-hotspot-edmiston.png`,
        active: `${origin}/deck-hotspot-active-default.png`,
        arrow: `${origin}/dropdown-arrow-edmiston.png`,
      };
    case "northropjohnson":
      return {
        hover: `${origin}/deck-hotspot-hover-northropjohnson.png`,
        default: `${origin}/deck-hotspot-northropjohnson.png`,
        active: `${origin}/deck-hotspot-active-default.png`,
        arrow: `${origin}/dropdown-arrow-northropjohnson.png`,
      };
    case "fraser":
      return {
        hover: `${origin}/deck-hotspot-hover-fraser.png`,
        default: `${origin}/deck-hotspot-fraser.png`,
        active: `${origin}/deck-hotspot-active-default.png`,
        arrow: `${origin}/dropdown-arrow-fraser.png`,
      };
    case "yachts":
      return {
        hover: `${origin}/deck-hotspot-hover-yachts.png`,
        default: `${origin}/deck-hotspot-yachts.png`,
        active: `${origin}/deck-hotspot-active-default.png`,
        arrow: `${origin}/dropdown-arrow-yachts.png`,
      };
    case "yco":
      return {
        hover: `${origin}/deck-hotspot-hover-yco.png`,
        default: `${origin}/deck-hotspot-yco.png`,
        active: `${origin}/deck-hotspot-active-yco.png`,
        arrow: `${origin}/dropdown-arrow-yco.png`,
      };
    case "sym":
      return {
        hover: `${origin}/deck-hotspot-hover-sym.png`,
        default: `${origin}/deck-hotspot-sym.png`,
        active: `${origin}/deck-hotspot-active-default.png`,
        arrow: `${origin}/dropdown-arrow-sym.png`,
      };
    case "lyc":
      return {
        hover: `${origin}/deck-hotspot-hover-lyc.png`,
        default: `${origin}/deck-hotspot-lyc.png`,
        active: `${origin}/deck-hotspot-active-default.png`,
        arrow: `${origin}/dropdown-arrow-lyc.png`,
      };
    default:
      return {
        hover: `${origin}/deck-hotspot-hover-default.png`,
        default: `${origin}/deck-hotspot-default.png`,
        active: `${origin}/deck-hotspot-active-default.png`,
        arrow: `${origin}/dropdown-arrow-default.png`,
      };
  }
};

export const getColour = () => {
  const subdomain = window.location.host.split(".")[0];
  switch (subdomain) {
    case "edmiston":
      return 0xdc0121;
    case "northropjohnson":
      return 0xfe7311;
    case "fraser":
      return 0xed8880;
    case "yachts":
      return 0xcccccc;
    case "yco":
      return 0xffc719;
    case "hillrobinson":
      return 0xffc719;
    case "sym":
      return 0xffffff;
    case "lyc":
      return 0xd7ff80;
    default:
      return 0x18c1d8;
  }
};

export const getTheme = () => {
  const subdomain = window.location.host.split(".")[0];
  if (window.location.pathname.includes("AM-437D")) {
    return {
      popupPrimary: "black",
      popupSecondary: "rgba(0, 0, 0, 0.7)",
      textPrimary: "#f3c736",
      textSecondary: "white",
      textShadow: "#1d1d1d",
      textHighlight: "#f3c736",
      dropdownPrimary: "#22262a",
      dropdownSecondary: "rgb(31, 43, 52)",
      dropdownTertiary: "rgba(0, 0, 0, 0.4)",
      linksPrimary: "rgb(34, 72, 83)",
      linksSecondary: "rgba(34, 72, 83, 0.8)",
      linksTertiary: "rgba(0, 0, 0, 0.4)",
      linksText: "white",
    };
  }
  switch (subdomain) {
    case "fraser":
      return {
        popupPrimary: "white",
        popupSecondary: "rgba(255, 255, 255, 0.7)",
        textPrimary: "#0A1B40",
        textSecondary: "#0A1B40",
        textShadow: "none",
        textHighlight: "#ED8880",
        dropdownPrimary: "white",
        dropdownSecondary: "rgba(255, 255, 255, 0.85)",
        dropdownTertiary: "rgba(255, 255, 255, 0.7)",
        linksPrimary: "rgb(34, 72, 83)",
        linksSecondary: "rgba(34, 72, 83, 0.8)",
        linksTertiary: "rgba(0, 0, 0, 0.4)",
        linksText: "white",
        pulse: "#ffbc0d",
      };
    case "yachts":
      return {
        popupPrimary: "white",
        popupSecondary: "rgba(255, 255, 255, 0.7)",
        textPrimary: "#0A1B40",
        textSecondary: "#0A1B40",
        textShadow: "none",
        textHighlight: "#37bbc8",
        dropdownPrimary: "white",
        dropdownSecondary: "rgba(255, 255, 255, 0.85)",
        dropdownTertiary: "rgba(255, 255, 255, 0.7)",
        linksPrimary: "rgb(34, 72, 83)",
        linksSecondary: "rgba(34, 72, 83, 0.8)",
        linksTertiary: "rgba(0, 0, 0, 0.4)",
        linksText: "white",
        pulse: "#ffbc0d",
      };

    // #ffc719
    case "yco":
      return {
        popupPrimary: "black",
        popupSecondary: "black",
        textPrimary: "#ffc719",
        textSecondary: "#ffffff",
        textShadow: "none",
        textHighlight: "#ffc619",
        textActive: "#ffc719",
        dropdownPrimary: "rgba(0, 0, 0, 0.6)",
        dropdownSecondary: "rgba(0, 0, 0, 0.6)",
        dropdownTertiary: "rgba(0, 0, 0, 0.6)",
        linksPrimary: "rgba(0, 0, 0, 0.6)",
        linksSecondary: "rgba(0, 0, 0, 0.6)",
        linksTertiary: "rgba(0, 0, 0, 0.6)",
        linksText: "#ffffff",
        linksTextActive: "#ffc719",
        popupSpace: 0,
        popupHeaderDirection: "row-reverse",
        pulse: "#ffbc0d",
      };

    // #ffc719
    case "hillrobinson":
      return {
        popupPrimary: "black",
        popupSecondary: "black",
        textPrimary: "#bba573",
        textSecondary: "#ffffff",
        textShadow: "none",
        textHighlight: "#bba573",
        textActive: "#bba573",
        dropdownPrimary: "rgba(15,32,78,0.9)",
        dropdownSecondary: "rgba(15,32,78,0.9)",
        dropdownTertiary: "rgba(15,32,78,0.7)",
        linksPrimary: "rgba(15,32,78,0.9)",
        linksSecondary: "rgba(15,32,78,0.9)",
        linksTertiary: "rgba(15,32,78,0.7)",
        linksText: "#ffffff",
        linksTextActive: "#bba573",
        popupSpace: 0,
        popupHeaderDirection: "row-reverse",
        pulse: "#bba573",
      };
    case "sym":
      return {
        popupPrimary: "black",
        popupSecondary: "black",
        textPrimary: "#f0c266",
        textSecondary: "#ffffff",
        textShadow: "none",
        textHighlight: "#ffc619",
        textActive: "#f0c266",
        dropdownPrimary: "rgba(14, 35, 58, 0.9)",
        dropdownSecondary: "rgba(14, 35, 58, 0.9)",
        dropdownTertiary: "rgba(14, 35, 58, 0.7)",
        linksPrimary: "rgba(14, 35, 58, 0.9)",
        linksSecondary: "rgba(14, 35, 58, 0.9)",
        linksTertiary: "rgba(14, 35, 58, 0.7)",
        linksText: "#ffffff",
        linksTextActive: "#f0c266",
        pulse: "#ffbc0d",
      };
    case "lifearc":
      return {
        popupPrimary: "black",
        popupSecondary: "rgba(0, 0, 0, 0.7)",
        textPrimary: "#37bbc8",
        textSecondary: "white",
        textShadow: "#1d1d1d",
        textHighlight: "#37bbc8",
        dropdownPrimary: "#22262a",
        dropdownSecondary: "rgb(31, 43, 52)",
        dropdownTertiary: "rgba(0, 0, 0, 0.4)",
        linksPrimary: "rgb(34, 72, 83)",
        linksSecondary: "rgba(34, 72, 83, 0.8)",
        linksTertiary: "rgba(0, 0, 0, 0.4)",
        linksText: "white",
        pulse: "#5acb5a",
      };
    case "lyc":
      return {
        popupPrimary: "black",
        popupSecondary: "black",
        textPrimary: "#f0c266",
        textSecondary: "#ffffff",
        textShadow: "none",
        textHighlight: "#ffc619",
        textActive: "#d7ff80",
        dropdownPrimary: "rgba(0, 46, 70, 0.9)",
        dropdownSecondary: "rgba(0, 46, 70, 0.9)",
        dropdownTertiary: "rgba(0, 46, 70, 0.7)",
        linksPrimary: "rgba(0, 46, 70, 0.9)",
        linksSecondary: "rgba(0, 46, 70, 0.9)",
        linksTertiary: "rgba(0, 46, 70, 0.7)",
        linksText: "#ffffff",
        linksTextActive: "#d7ff80",
        pulse: "#d7ff80",
      };
    default:
      return {
        popupPrimary: "black",
        popupSecondary: "rgba(0, 0, 0, 0.7)",
        textPrimary: "#37bbc8",
        textSecondary: "white",
        textShadow: "#1d1d1d",
        textHighlight: "#37bbc8",
        dropdownPrimary: "#22262a",
        dropdownSecondary: "rgb(31, 43, 52)",
        dropdownTertiary: "rgba(0, 0, 0, 0.4)",
        linksPrimary: "rgb(34, 72, 83)",
        linksSecondary: "rgba(34, 72, 83, 0.8)",
        linksTertiary: "rgba(0, 0, 0, 0.4)",
        linksText: "white",
        pulse: "#ffbc0d",
      };
  }
};
